module.exports = __webpack_public_path__ + "img/rolaids_ultra_strength_chewable_tablets.d6fd87d5.jpg";